import type { Reservation } from "@/types/reservation";
import { StatusBadge } from "./StatusBadge";
import { formatDate, formatTime } from "@/lib/date";

export function ReservationCard({
  reservation,
  pcName,
  userName,
  onClick,
}: {
  reservation: Reservation;
  pcName: string;
  userName: string;
  onClick?: () => void;
}) {
  const sameDay = formatDate(reservation.start_at) === formatDate(reservation.end_at);
  return (
    <div className="reservation-card" onClick={onClick} role={onClick ? "button" : undefined}>
      <div className="reservation-card-top">
        <span className="reservation-card-name">
          {userName} ／ {pcName}
        </span>
        <StatusBadge status={reservation.status} />
      </div>
      <div className="reservation-card-meta">
        {sameDay
          ? `${formatDate(reservation.start_at)} ${formatTime(reservation.start_at)}〜${formatTime(reservation.end_at)}`
          : `${formatDate(reservation.start_at)} ${formatTime(reservation.start_at)}〜${formatDate(reservation.end_at)} ${formatTime(reservation.end_at)}`}
      </div>
      {reservation.purpose && <div className="reservation-card-meta">目的：{reservation.purpose}</div>}
    </div>
  );
}
